<template>
<div class="row">
  <div class="col-12 col-md-12 right-side p-4 ">
      <div class="middle-box loginscreen py-0 px-3 d-flex flex-column justify-content-center">
        <h2 class="fw-normal text-center text-muted mb-4">Please enter your IDS password</h2>
         <form class="m-t" role="form" action="index.html" autocomplete="on">
            <div class="form-group position-relative" :class="{'mb-4':errorBlock==false,'mb-2':errorBlock==true}">
                <input :type="inputType" name="password" class="form-control"  placeholder="Password" v-model="password" required>
                <i class="password-block cursor-pointer position-absolute"
              :class="[visibleOn ? 'fa fa-eye' : 'fa fa-eye-slash']" @click.prevent="passwordVisible()"></i>
            </div>
            <div class="mb-2" v-if="errr">
              <span class="error-message">{{ errr }}</span>
           </div>
           <div>
            <button type="button" class="save_btn py-1 px-4 w-100 position-relative"
              @click="login" :class="{ 'disabled-btn-cls': loginLoader == true }">
              <div class="login-loader position-absolute"
              :class="{ 'opacity-0': loginLoader == false, 'opacity-1': loginLoader == true }">
              <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
              </div>
              <p class="mb-0" :class="{ 'opacity-1': loginLoader == false, 'opacity-0': loginLoader == true }">{{
              $t("navigations.login") }}</p>
            </button>
           </div>            
          </form>
      </div>
  </div>
</div> 
 <teleport to='#app'>
     <div class="blank-wrapper" v-if="initialLoader==true">
      <div class="text-center">
        <h2>{{`Please wait while redirecting..`}}</h2>
        <img src="../../assets/img/loading.gif" width="15"  alt="Waiting for login" />
      </div>
    </div>
</teleport>
</template>

<script src="./folderDocLogin.js">
</script>

<style>
.blank-wrapper{
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  color:rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
  pointer-events: auto;
}
.middle-box {
    max-width: 400px;
    z-index: 100;
    margin: 0 auto;
}
.right-side{
  height:100vh;
  overflow:hidden
}
.loginscreen.middle-box{
height:100%;
}
.other-block{
  position: relative;
}
.middle-box a{
  display: block;
  text-align: right;
  text-decoration: none;
}
.error-message{
  color:hsl(0, 100%, 50%);
}
.password-block {
    right: 11px;
    top: 8px;
}
.login-loader
{   
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
</style>
